import { api } from "@/shared/libs/axiosClient";

export interface MemberResponse {
  id: number;
  name: string;
  phone: string | null;
  email: string;
  picture: string | null;
  grant: "member" | "admin" | null;
  created_at: string | null;
}

export interface MemberGrantResponse {
  member_id: number;
  grant: "member" | "admin";
}

export interface MemberCreate {
  email: string;
  grant?: "member" | "admin";
}

export interface MemberUpdate {
  phone?: string;
}

export async function fetchMembers(): Promise<MemberResponse[]> {
  return api.get<MemberResponse[]>("/member");
}

export interface MemberNameMapResponse {
  id: number;
  name: string;
  picture: string | null;
}

export async function fetchMemberNameMap(): Promise<MemberNameMapResponse[]> {
  return api.get<MemberNameMapResponse[]>("/member/name-map");
}

export async function getMember(memberId: number): Promise<MemberResponse> {
  return api.get<MemberResponse>(`/member/${memberId}`);
}

export async function createMember(data: MemberCreate): Promise<MemberResponse> {
  return api.post<MemberResponse>("/member", data);
}

export async function updateMember(memberId: number, data: MemberUpdate): Promise<MemberResponse> {
  return api.patch<MemberResponse>(`/member/${memberId}`, data);
}

export async function deleteMember(memberId: number): Promise<{ deleted: boolean; member_id: number }> {
  return api.delete<{ deleted: boolean; member_id: number }>(`/member/${memberId}`);
}

export async function updateMemberGrant(
  memberId: number,
  grant: "member" | "admin",
): Promise<MemberGrantResponse> {
  return api.patch<MemberGrantResponse>(`/member/${memberId}/grant`, { grant });
}

export interface TeamMemberResponse {
  team_id: number;
  member_id: number;
  created_at: string | null;
}

export async function fetchTeamMembers(teamId: number): Promise<TeamMemberResponse[]> {
  return api.get<TeamMemberResponse[]>(`/team/${teamId}/member`);
}

export async function addTeamMember(
  teamId: number,
  memberId: number,
): Promise<TeamMemberResponse> {
  return api.post<TeamMemberResponse>(`/team/${teamId}/member`, {
    member_id: memberId,
  });
}

export async function deleteTeamMember(
  teamId: number,
  memberId: number,
): Promise<{ deleted: boolean; team_id: number; member_id: number }> {
  return api.delete<{ deleted: boolean; team_id: number; member_id: number }>(
    `/team/${teamId}/member/${memberId}`,
  );
}
